"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var OptimizationScenarioConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(OptimizationScenarioConverter, _DataObjectConverter_);

  function OptimizationScenarioConverter() {
    _classCallCheck(this, OptimizationScenarioConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenarioConverter).apply(this, arguments));
  }

  return OptimizationScenarioConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.OptimizationScenarioConverter = OptimizationScenarioConverter;